import React from "react";
import BasicModal from "./BasicModal";
import {
	Box,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
	Typography,
} from "@mui/material";
import { sizes } from "../scenarioSetupNewUtils";
import MultipleSelectChip from "./MultipleSelectChip";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "../scenarioSetupNewSlice";

const commonHeight = sizes.h35;
const SW = sizes.w300;

export default function DefineLinkDataSources() {
	const dispatch = useDispatch();
	const setupState = useSelector((store) => store.scenarioSetupNew);
	const { selectedDSs, selectedPDS, dataSources } = setupState;

	const handlePrimaryDataSource = (event) => {
		const dataSource = event.target.value;
		const id = dataSources.find(
			(source) => source.dataSourceName === dataSource
		).dataSourceID;
		dispatch(setState("selectedPDS", dataSource));
		dispatch(setState("primaryDataSourceID", id));
	};

	return (
		<grid container columns={12} justifyContent="space-between" rowSpacing={0} >
			{/* <Box sx={{ mt: 5, marginLeft:"auto", }}>
				<Typography sx={{ color: "lightBlue.main", fontWeight: "bold" }} className="compHeading">
					Define and Link Data Sources
				</Typography>
			</Box> */}
			<Grid container sx={{mb: 4, mt: -.5,}}>
				<Grid item sm={8}>
					<Box>
						<MultipleSelectChip />
					</Box>
				</Grid>

				<Grid item sm={2} md={2} lg={2}>
					<Box sx={{ mt: 2, mr:2}}>
						<FormControl sx={{ width: "100%" }}>
							<InputLabel id="demo-simple-select-label">
								Primary Data Source
							</InputLabel>
							<Select
								labelId="demo-simple-select-label"
								id="demo-simple-select"
								value={selectedPDS}
								label="primary data sources"
								sx={{
									height: commonHeight,
									width: SW,
									color: "black.main",
									mt: 1,
								}}
								onChange={handlePrimaryDataSource}
							>
								{selectedDSs.map((source, index) => {
									return (
										<MenuItem key={index} value={source}>
											{source}
										</MenuItem>
									);
								})}
							</Select>
						</FormControl>
					</Box>
				</Grid>

				<Grid item sm={2} md={2} lg={2}>
					<Box>
						<BasicModal />
					</Box>
				</Grid>
			</Grid>
			

		</grid>
						
	);
}
